import UAParser from 'ua-parser-js';

import axios from 'axios';
import SuccessDetail from '../../../components/local/success-stories/SuccessDetail';
import RelatedStories from '../../../components/local/success-stories/RelatedStories';

import { getStrapiURL } from '../../../lib/api';
const apiBaseUrl = getStrapiURL();
import Share from '../../../components/shared/Share';
import SiteHeader from '../../../components/shared/SiteHeader';

const SuccessStory = ({ storyData, error, relatedPosts, deviceType }) => {
  if (error)
    return <div className="my-40 mx-20 flex items-center justify-center">404 | Page not found</div>;
  return (
    <>
      <SiteHeader
        title={storyData?.title}
        desc={storyData?.tagline}
        image={storyData?.cardImage?.data?.attributes?.url}
        url={`/success-stories/${storyData?.slug}`}
      />
      <div className="container-default-1209px">
        <div className="relative w-auto py-8 sm:px-0 lg:mx-12 lg:px-8">
          <div className="hidden lg:block">
            <div className="top-[120px] -mr-10 lg:sticky lg:float-right">
              <Share slug={`success-stories/${storyData.slug}`} />
            </div>
            <SuccessDetail storyData={storyData} deviceType={deviceType} />
          </div>

          <div className="lg:hidden">
            <SuccessDetail deviceType={deviceType} storyData={storyData} />
          </div>
          <RelatedStories relatedPosts={relatedPosts} deviceType={deviceType} />
        </div>
      </div>
    </>
  );
};

export default SuccessStory;

export const getServerSideProps = async ({ query, req, res }) => {
  let userAgent;
  if (req) {
    userAgent = req.headers['user-agent'];
  } else {
    userAgent = navigator.userAgent;
  }
  const parser = new UAParser();
  parser.setUA(userAgent);
  const result = parser.getResult();
  const deviceType = (result.device && result.device.type) || 'desktop';
  const { slug } = query;
  try {
    const { data } = await axios.get(
      `${apiBaseUrl}/api/testimonials?filters[slug][$eq]=${slug}&populate=avatar&populate=companyLogo&populate=cardImage`
    );
    const storyData = data.data[0].attributes;

    const reletedVideoStroies = storyData.videoLink ? true : false;
    if (reletedVideoStroies) {
      const { data: relatedPosts } = await axios.get(
        `${apiBaseUrl}/api/testimonials?populate=cardImage&pagination[page]=1&pagination[pageSize]=10&filters[$and][0][slug][$notContains]=${slug}&filters[$and][1][videoLink][$notNull]=true&populate=avatar&populate=companyLogo`
      );
      res.setHeader('Cache-Control', 'public, s-maxage=3600, stale-while-revalidate');
      return { props: { storyData, relatedPosts } };
    } else {
      const { data: relatedPosts } = await axios.get(
        `${apiBaseUrl}/api/testimonials?populate=avatar&populate=companyLogo&pagination[page]=1&pagination[pageSize]=6&filters[$and][0][slug][$notContains]=${slug}&filters[$and][1][videoLink][$null]=true&populate=avatar&populate=companyLogo`
      );
      res.setHeader('Cache-Control', 'public, s-maxage=3600, stale-while-revalidate');
      return { props: { deviceType, storyData, relatedPosts } };
    }
  } catch (error) {
    console.log(error);
    return { deviceType, error };
  }
};
